/**
 * Single-row heatmap of weekly quantities for one customer. Each cell is one
 * ISO week. Intensity scales with qty relative to the customer's max week.
 */

const monthLabel = (iso: string) => {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

function bgColor(qty: number, max: number): string {
  if (qty === 0) return "#f3f4f6"; // ink-100
  const t = max === 0 ? 0 : qty / max;
  // Indigo ramp 100 → 700 (approx)
  const a = Math.max(0.18, Math.min(1, t));
  return `rgba(79, 70, 229, ${a})`;
}

interface Props {
  data: { week: string; qty: number }[];
}

export default function WeeklyHeatmap({ data }: Props) {
  const max = data.reduce((m, d) => Math.max(m, d.qty), 0);
  return (
    <div className="overflow-x-auto">
      <div className="flex gap-1.5">
        {data.map((d) => {
          const t = bgColor(d.qty, max);
          const ink = d.qty / Math.max(max, 1) > 0.5 ? "white" : "#1f2937";
          return (
            <div key={d.week} className="flex flex-col items-center gap-1">
              <div
                title={`Week of ${d.week}: ${d.qty}`}
                style={{ background: t, color: ink }}
                className="flex h-10 w-10 items-center justify-center rounded-md text-xs font-medium tabular-nums"
              >
                {d.qty || ""}
              </div>
              <span className="text-[10px] text-ink-500">{monthLabel(d.week)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
